<div class="empty">
    <mat-icon svgIcon="cart"></mat-icon>
    <p>Your cart is empty</p>
</div>